import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import SearchWidget from 'common/components/SearchWidget';
import {Layout, Table, Text} from '@phonectas/unifon-ui-kit';
import {ROUTES} from 'common/constants';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {ResponsibleAccount} from './types';

interface Props {
	data: {
		name: string;
		entra_id: string;
		customers_count: number;
	}
}

const RenderItemDetails: React.FC<Props> = ({data}) => {
	const [t] = useTranslation();
	const navigate = useNavigate();
	const dataTable = useThreeSixtyNewStore((state) => state?.activeCustomerResp);
	const [searchQuery, setSearchQuery] = useState('');

	const handleSearchQuery = useCallback((value: string) => {
		setSearchQuery(value);
	}, []);

	const handleCrearQuery = useCallback(() => {
		setSearchQuery('');
	}, []);

	const handleClickedRow = useCallback((item: ResponsibleAccount) => {
		navigate(`${ROUTES.THREE_SIXTY}/${item?.id}`);
	}, [navigate]);

	const renderItem = useCallback((item: ResponsibleAccount, index: number) => (
		<Table.Row
			key={index}
			index={index}
			onClick={() => handleClickedRow(item)}
			style={{padding: '0 16px'}}
		>
			<Table.Cell>
				<Text truncate={1}>{item?.name}</Text>
			</Table.Cell>
			<Table.Cell><Text>{item?.products?.mobiles_active_count}</Text></Table.Cell>
			<Table.Cell><Text>{item?.vat_number}</Text></Table.Cell>
		</Table.Row>
	), [handleClickedRow]);

	const filteredList = dataTable?.accounts?.filter((item) => {
		return (item.name ?? '').toLowerCase().includes(searchQuery.toLowerCase());
	});

	return (
		<Layout
			fullWidth
			fullHeight
			style={{
				overflow: 'hidden',
			}}
			gap="sm"
		>
			<Layout fullWidth gap="xs" nowrap direction="column">
				<Layout fullWidth nowrap justifyContent="space-between">
					<Layout fullWidth>
						<SearchWidget
							placeholder={t('Search')}
							onChange={handleSearchQuery}
							clearSearch={handleCrearQuery}
							value={searchQuery}
							fullWidth
						/>
					</Layout>
					<Layout fullWidth alignItems="center" justifyContent="end">
						<Text variant="h4">{data?.name}</Text>
					</Layout>
				</Layout>
			</Layout>
			<Layout
				fullWidth
				direction="row"
				fullHeight
				style={{paddingBottom: '40px'}}
			>
				<Table
					items={filteredList || []}
					renderItem={renderItem}
				>
					<Table.Row
						style={{padding: '0 16px'}}
					>
						<Table.Cell>{t('Customer')}</Table.Cell>
						<Table.Cell width={100}>{t('Mobiles')}</Table.Cell>
						<Table.Cell width={90}>{t('Org. number')}</Table.Cell>
					</Table.Row>
				</Table>
			</Layout>
		</Layout>
	);
}

export default RenderItemDetails;
